import { api } from "./api";

export const meaguresApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getMeagures: builder.query({
      query: () => "api/Stock/Meagures",
      providesTags: ["meagures"],
    }),
    addMeagure: builder.mutation({
      query: (formData) => ({
        url: "api/Stock/Meagures",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["meagures"],
    }),
    editMeagure: builder.mutation({
      query: (formData) => ({
        url: "api/Stock/Meagures",
        method: "PUT",
        body: formData,
      }),
      invalidatesTags: ["meagures"],
    }),
    deleteMeagure: builder.mutation({
      query: (meagureId) => ({
        url: `api/Stock/Meagures?MeagureID=${meagureId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["meagures"],
    }),
  }),
});

export const {
  useGetMeaguresQuery,
  useAddMeagureMutation,
  useEditMeagureMutation,
  useDeleteMeagureMutation,
} = meaguresApi;
